import { Table, TableBody } from '@mui/material';

import type { Dispatch, SetStateAction } from 'react';

import type { DocumentType } from '@/gql';
import { graphql } from '@/gql';

import type { FileManagerUploadingState } from '../FileManagerUploadingBar';

import { UploadingFileRow } from './uploading-files-table/UploadingFileRow';

const UPLOADING_FILE_TABLE_FILES_FOR_OWNER_FRAGMENT = graphql(`
  fragment uploadingFileTableFilesForOwnerFields on FilesForOwner {
    ...uploadingFileRowFilesForOwnerFields
  }
`);

interface Props {
  filesForOwner: DocumentType<
    typeof UPLOADING_FILE_TABLE_FILES_FOR_OWNER_FRAGMENT
  >;
  uploadingState: FileManagerUploadingState;
  setUploadingState: Dispatch<SetStateAction<FileManagerUploadingState>>;
}

export const UploadingFilesTable = ({
  filesForOwner,
  uploadingState,
  setUploadingState,
}: Props) => {
  const { uploadingFiles, uploadingFolders, uploadingZipFiles } =
    uploadingState;

  const itemsForRow = [
    ...uploadingFolders.map((folder) => {
      return {
        id: folder.id,
        startedAt: folder.startedAt,
        filename: folder.filename,
        parent: folder.parent,
        progress: folder.created ? 1 : 0,
        error: folder.error,
        folder: true,
        zip: false,
      };
    }),
    ...uploadingZipFiles.map((file) => {
      return {
        id: file.id,
        filename: file.filename,
        startedAt: file.startedAt,
        parent: file.parent,
        error: file.error,
        folder: false,
        zip: true,
        progress: file.totalBytes ? file.uploadedBytes / file.totalBytes : 0,
        status: file.zipStatus,
      };
    }),
    ...uploadingFiles.map((file) => {
      return {
        id: file.id,
        filename: file.filename,
        startedAt: file.startedAt,
        parent: file.parent,
        error: file.error,
        folder: false,
        zip: false,
        progress: file.totalBytes ? file.uploadedBytes / file.totalBytes : 0,
      };
    }),
  ];

  return (
    <Table>
      <TableBody>
        {itemsForRow.map((item) => (
          <UploadingFileRow
            key={`${String(item.folder)}${String(item.zip)}${item.id}`}
            file={item}
            filesForOwner={filesForOwner}
            setUploadingState={setUploadingState}
          />
        ))}
      </TableBody>
    </Table>
  );
};
